import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Small confirmation dialog that collects a customer first name before
// sending a table-less ticket to the kitchen. Fires whenever a ticket
// has items but no table, customer, or ticket-name assignment.
const QuickOrderNameDialog = ({ open, onOpenChange, value, onChange, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[420px]" data-testid="quick-order-name-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading text-xl">Who&apos;s this order for?</DialogTitle>
      </DialogHeader>
      <div className="space-y-3 pt-2">
        <p className="text-sm text-muted-foreground">
          Enter a first name so the kitchen can call the order when it&apos;s ready.
        </p>
        <Input
          autoFocus
          placeholder="e.g. Sarah"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") onConfirm(); }}
          data-testid="quick-order-name-input"
        />
      </div>
      <DialogFooter className="gap-2">
        <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="quick-order-name-cancel">
          Cancel
        </Button>
        <Button onClick={onConfirm} data-testid="quick-order-name-confirm">
          Send to Kitchen
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default QuickOrderNameDialog;
